// store-utils.js
import store from '@/store';

export const handleInvalidToken = (social) => {
  store.dispatch('AUTH_REMOVE_TOKEN', { social });
};